export default {
	title: "Style variation name",
	settings: {
		typography: {
			fontSizes: [
				{
					name: "Font size name",
				},
			],
			fontFamilies: [
				{
					name: "Font family name",
				},
			],
		},
		color: {
			palette: [
				{
					name: "Color name",
				},
			],
			gradients: [
				{
					name: "Gradient name",
				},
			],
			duotone: [
				{
					name: "Duotone name",
				},
			],
		},
		spacing: {
			spacingSizes: [
				{
					name: "Space size name",
				},
			],
		},
		blocks: {
			"*": {
				typography: {
					fontSizes: [
						{
							name: "Font size name",
						},
					],
					fontFamilies: [
						{
							name: "Font family name",
						},
					],
				},
				color: {
					palette: [
						{
							name: "Color name",
						},
					],
					gradients: [
						{
							name: "Gradient name",
						},
					],
				},
				spacing: {
					spacingSizes: [
						{
							name: "Space size name",
						},
					],
				},
			},
		},
	},
	customTemplates: [
		{
			title: "Custom template name",
		},
	],
	templateParts: [
		{
			title: "Template part name",
		},
	],
};
